import { cn } from "@/lib/utils"

/** Brand Tropical Surf — profile/account titles in light mode; full white in dark sidebar shell. */
export const sidebarTropicalSurfClass = "text-[#38BBD1] dark:!text-white"

/** Sidebar muted chrome — light grey labels; full white in dark mode. */
export const sidebarGray500Class =
  "text-sidebar-muted-foreground dark:!text-white"

/** Secondary line under account / profile titles in the sidebar shell. */
export const sidebarSecondaryTextClass =
  "text-muted-foreground dark:!text-white"

/** Glacial Red — logout icon stays red (not gray / teal profile menu chrome). */
export const SIDEBAR_GLACIAL_RED = "#FE4244"

export const sidebarLogoutIconClass =
  "text-[#FE4244] [&_svg]:text-[#FE4244] [&_svg]:stroke-[#FE4244]"

/** Collapsed sidebar-07 icon rail: 32px control, icon centered, no label gap. */
export const sidebarMenuButtonIconRailClass =
  "group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!justify-center group-data-[collapsible=icon]:!gap-0 group-data-[collapsible=icon]:!p-0"

/** Notifications centre nested rail — always icon-only (matches collapsed dashboard sidebar). */
export const notificationsCentreIconRailButtonClass =
  "size-8! justify-center! gap-0! p-0! [&_svg]:size-4"

/** Inbox list row — rounded box with sidebar hover/active chrome. */
export const notificationsCentreInboxItemClass =
  "rounded-md transition-[background-color] duration-200 ease-linear hover:bg-sidebar-accent data-[active=true]:bg-sidebar-accent"

/** Wrapper for animated / custom icons in profile dropdown rows. */
export const sidebarProfileMenuIconClass =
  "transition-colors group-hover/profile-menu-item:!text-[#38BBD1] group-focus-visible/profile-menu-item:!text-[#38BBD1] group-data-[highlighted]/profile-menu-item:!text-[#38BBD1] [&_svg]:text-current"

/**
 * Profile menu rows portal outside the app shell. Prefer theme-aware classes
 * (not only `dark:`) so portaled links stay white when html has `.dark`.
 */
export function sidebarProfileMenuItemClassName(isDark: boolean): string {
  return cn(
    "group/profile-menu-item flex min-h-8 w-full items-center gap-2 rounded-md p-2 text-sm transition-colors",
    isDark ? "!text-white" : "text-sidebar-muted-foreground",
    "hover:bg-sidebar-accent hover:!text-[#38BBD1]",
    "focus-visible:bg-sidebar-accent focus-visible:!text-[#38BBD1]",
    "data-[highlighted]:bg-sidebar-accent data-[highlighted]:!text-[#38BBD1]",
    "[&_svg]:size-4 [&_svg]:shrink-0",
    isDark ? "[&_svg]:!text-white" : "[&_svg]:text-sidebar-muted-foreground",
    "hover:[&_svg]:!text-[#38BBD1] focus-visible:[&_svg]:!text-[#38BBD1]",
    "data-[highlighted]:[&_svg]:!text-[#38BBD1]"
  )
}

export function sidebarProfileMenuIconClassName(isDark: boolean): string {
  return cn(
    sidebarProfileMenuIconClass,
    isDark ? "!text-white" : "text-sidebar-muted-foreground"
  )
}

/** @deprecated Prefer sidebarProfileMenuItemClassName(isDark) for portaled rows. */
export const sidebarProfileMenuItemClass = sidebarProfileMenuItemClassName(false)
